import React from 'react';
import Radial from './svg/Radial';

const Subscription = () => {
  return (
    <section id="get-onboard" className="">
      <Radial />
    </section>
  );
};
export default Subscription;
